const ProviderPermissions = {
  edit: 'provider:edit',
  create: 'provider:create',
  delete: 'provider:delete',
  view: 'provider:view',
}

export default ProviderPermissions
